import CollectionApi from 'client/api/v2/CollectionApi';

class GroupApi extends CollectionApi {
  constructor() {
    super('/api/v2/groups', {
      skip: 0,
      limit: 50,
      fields: [
        'suggestionCounts.total',
        'membershipMethod',
        'memberQuery',
        'memberQueryExemptions',
      ],
      sort: 'name', // Prepend with a '-' to reverse default sort direction
      filter: [{
        name: 'name',
        operator: 'search',
        value: '',
      }],
    });
  }

  getGroupsWithSuggestions(skip, limit) {
    return this.axios.get(`${this.baseUrl}?skip=${skip}&limit=${limit}
      &fields=suggestionCounts.total&sort=name&filter=type%3Aeq%3Auser_group&filter=suggestionCounts.total:gt:0`);
  }
}
export default new GroupApi();
